import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
  inject,
  signal,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  BottomSheetComponent,
  DeviceService,
  TabsInkbarFixDirective,
} from '@nomoh-monorepo/shared-common-ui';
import { IEstabelecimentoClienteEntity } from '@nomoh-monorepo/shared-types';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TabsModule } from 'primeng/tabs';
import { TooltipModule } from 'primeng/tooltip';
import { NichoTermosService } from '@nomoh-monorepo/data-access-bardo-administrador';
import { TranslateModule } from '@ngx-translate/core';
import { ClienteCreateEditComponent } from './cliente-create-edit/cliente-create-edit.component';
import { ClienteInfoComponent } from './cliente-info/cliente-info.component';
import { ClienteVinculosComponent } from './cliente-vinculos/cliente-vinculos.component';


@Component({
  selector: 'lib-cliente-view-modal',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    TooltipModule,
    ReactiveFormsModule,
    BottomSheetComponent,
    ClienteInfoComponent,
    ClienteVinculosComponent,
    TabsModule,
    TabsInkbarFixDirective,
    ClienteCreateEditComponent,
    TranslateModule,
  ],
  templateUrl: './cliente-view-modal.component.html',
  styleUrls: ['./cliente-view-modal.component.scss'],
})
export class ClienteViewModalComponent implements OnChanges {
  //#region input e output
  @Input() set visible(v: boolean) {
    this.$internalVisible.set(v);
  }
  get visible(): boolean {
    return this.$internalVisible();
  }

  @Input() cliente: IEstabelecimentoClienteEntity | null = null;
  @Output() closed = new EventEmitter<void>();
  @Output() saved = new EventEmitter<void>();
  @Output() vinculoAlterado = new EventEmitter<void>();

  //#endregion

  //#region injeção de dependências
  deviceService = inject(DeviceService);
  $nicho = inject(NichoTermosService).$nicho;

  //#endregion

  //#region signals
  activeTab = signal<string>('view');
  $internalVisible = signal(false);
  //#endregion

  //#region propriedades
  footerTemplate: TemplateRef<unknown> | null = null;

  tabs = [
    { id: 'view', labelKey: 'BARDO_CLIENTES.TABS.VIEW', label: 'Visualizar', icon: 'pi pi-eye' },
    { id: 'editar', labelKey: 'BARDO_CLIENTES.TABS.EDITAR', label: 'Editar', icon: 'pi pi-pencil' },
    { id: 'vinculos', labelKey: 'BARDO_CLIENTES.TABS.VINCULOS', label: 'Vínculos', icon: 'pi pi-users' },
    { id: 'criar', labelKey: 'BARDO_CLIENTES.TABS.CRIAR', label: 'Criar', icon: 'pi pi-plus' },
  ];




  //#endregion


  ngOnChanges(changes: SimpleChanges) {
    if (changes['visible']?.currentValue === true) {
      this.footerTemplate = null;
      this.activeTab.set(this.cliente === null ? 'criar' : 'view');
    }
  }

  tabVisivel(tabId: string): boolean {
    if (tabId === 'criar') return this.cliente === null;
    return this.cliente !== null;
  }

  onTabChange(tabId: string | number) {
    this.activeTab.set(String(tabId));
  }

  onSaved() {
    this.saved.emit();
  }

  onVinculoAlterado() {
    this.vinculoAlterado.emit();
  }

  fechar() {
    this.$internalVisible.set(false);
    this.closed.emit();
  }

  fecharAbaCriarEditar() {
    if (this.cliente?.id) {
      this.activeTab.set('view');
    } else {
      this.fechar();
    }
  }

  footerTemplateAction(template: TemplateRef<unknown>): void {
    this.footerTemplate = template;
  }
}
